export default __webpack_public_path__ + "static/media/result_cup.f45bc725.svg";